<template lang='pug'>
v-navigation-drawer.app--drawer(
	app,
	v-model='hasShowDrawer',
	:width='responsiveWidth',
	overlay-opacity='0.55',
	overlay-color='#0F1A24'
)
	v-list.menu-list(dense, expand, nav)
		template(v-for='item in menus')
			// group with subitems
			v-list-group.menu-group(
				v-if='item.items',
				v-model='item.active',
				:key='item.title',
				:prepend-icon='item.icon',
				no-action,
				@click='close(item)',
				color='white'
			)
				v-list-item.pa-0.group-activator(slot='activator', ripple, color='secondary')
					v-list-item-content
						v-list-item-title.d-flex.align-center
							span {{ item.title }}
							span.new-badge(v-if='item.is_new') NEW
				template(v-for='subItem in item.items')
					v-divider.menu-divider(v-if='subItem.isDivider', :key='subItem.name')
					v-list-item.category-title(
						v-else-if='subItem.isCategory',
						:key='subItem.name',
						:style='categoryColorStyle(subItem.name)'
					)
						v-list-item-content
							v-list-item-title {{ $t(`menu.${subItem.title}`) }}

					// child item
					v-list-item.menu-bgc(
						v-else,
						:key='subItem.name',
						:to='genChildTarget(item, subItem)',
						:href='subItem.href',
						:disabled='subItem.disabled',
						:target='subItem.target',
						ripple,
						color='secondary',
						:class="{'category-child': subItem.category}",
						:style='categoryColorStyle(subItem.category)'
					)
						v-list-item-content
							v-list-item-title
								span.sec-font-color {{ subItem.title }}
						v-list-item-action(v-if='subItem.action')
							v-icon(:class='[subItem.actionClass || "success--text"]') {{ subItem.action }}
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { getCategoryColor } from '@/theme/categories';
import { SHOW_NEW_BADGES } from '@/assets/constant/feature_flags';
export default {
	name: 'AppDrawer',
	props: {
		drawWidth: {
			type: [Number, String],
			default: '260',
		},
	},
	data() {
		return {
			windowsWidth: '',
			menus: [],
			hasShowDrawer: false,
		};
	},
	computed: {
		...mapGetters(['permission_routers', 'getDrawerStatus']),
		responsiveWidth() {
			const bp = this.$vuetify.breakpoint;
			if (bp.xsOnly) {
				return Math.min(Math.round(bp.width * 0.85), 320);
			}
			return this.drawWidth;
		},
	},
	created() {
		this.createRouter();
	},
	mounted() {
		this.drawerStatus();
	},
	methods: {
		...mapActions(['setDrawerStatus']),
		categoryColorStyle(categoryName) {
			if (!categoryName || !categoryName.startsWith('category_')) return {};
			return { '--cat-color': getCategoryColor(categoryName) };
		},
		genChildTarget(item, subItem) {
			if (subItem.href) return;
			if (subItem.component) {
				return {
					name: subItem.component,
				};
			}
			// return { name: `${item.group}/${subItem.name}` };
		},
		createRouter() {
			const Menu = [];
			// eslint-disable-next-line no-undef
			for (const i of this.permission_routers) {
				if (!i.hidden) {
					if (i.meta.group === 'ocms') {
						Menu.push({ header: '' });
					}
					if (i.meta.group === 'onlineGeneral') {
						Menu.push({ header: '' });
					}
					if (i.meta.group === 'ocmsDataMonitor') {
						Menu.push({ header: '' });
					}
					if (i.meta.group === 'customer') {
						Menu.push({ header: '' });
					}
					const tmpObj = {};
					tmpObj.title = i.meta.title;
					tmpObj.group = i.meta.group;
					tmpObj.icon = i.meta.icon;
					tmpObj.is_new = SHOW_NEW_BADGES && (i.path === '/sys_provider' || i.path === '/site_owner');
					if (i.children) {
						tmpObj.items = [];
						// 用于跟踪已添加的分类
						const addedCategories = new Set();

						// 按照 itemIdx 排序子项
						const sortedChildren = [...i.children].sort((a, b) => a.meta.itemIdx - b.meta.itemIdx);

						for (const j of sortedChildren) {
							// 检查是否有分类信息
							if (j.meta.category && !addedCategories.has(j.meta.category)) {
								// 添加分类标题
								tmpObj.items.push({
									name: `divider_${j.meta.category}`,
									isDivider: true,
								});
								tmpObj.items.push({
									name: j.meta.category,
									title: j.meta.category,
									isCategory: true,
								});
								// 标记该分类已添加
								addedCategories.add(j.meta.category);
							}

							// 添加实际菜单项
							tmpObj.items.push({
								name: j.name,
								title: j.meta.title,
								component: j.name,
								category: j.meta.category,
							});
						}
					}
					Menu.push(tmpObj);
				}
			}
			this.menus = Menu;
		},
		goHome() {
			this.$router.push({ path: '/dashboard' });
		},
		drawerStatus() {
			this.hasShowDrawer = this.getDrawerStatus;
		},
		close(currentItem) {
			this.menus.forEach((item) => {
				if (item !== currentItem && item.active) {
					item.active = false;
				}
			});
		}
	},
	watch: {
		getDrawerStatus() {
			this.drawerStatus();
		},
		hasShowDrawer(val) {
			this.setDrawerStatus(val);
		},
	},
};
</script>

<style lang='stylus'>
$accent = #3498DB
$accent-soft = rgba(52, 152, 219, 0.16)
$accent-softer = rgba(52, 152, 219, 0.08)
$ease = cubic-bezier(0.4, 0, 0.2, 1)

.app--drawer {
  position: fixed;
  overflow: hidden;
  background: linear-gradient(180deg, #2C3E50 0%, #1A2530 100%);
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.28);
  border-right: none;

  .menu-list {
    padding: 8px 6px;
  }

  // 群組 (頂層) header
  .menu-group {
    margin-bottom: 2px;

    &::before {
      display: none;
    }

    .v-list-group__header {
      min-height: 48px;
      padding: 0 12px;
      margin: 2px 0;
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.04);
      transition: background 0.25s $ease, color 0.25s $ease, border-radius 0.2s $ease, margin-bottom 0.2s $ease;

      &::before {
        border-radius: 8px;
      }

      .v-list-item__icon {
        margin: 12px 12px 12px 0;
      }

      .v-list-item__title > span:not(.new-badge) {
        font-size: 0.9375rem;
        font-weight: 500;
        letter-spacing: 0.01em;
        color: rgba(255, 255, 255, 0.88);
        transition: color 0.25s $ease;
      }

      .v-icon {
        color: rgba(255, 255, 255, 0.6);
        transition: color 0.25s $ease;
      }

      &:hover {
        background: $accent-softer;

        .v-list-item__title > span:not(.new-badge),
        .v-icon {
          color: rgba(255, 255, 255, 1);
        }
      }
    }

    // 展開時: header 與下方下凹面板無縫接合
    &.v-list-group--active > .v-list-group__header {
      background: $accent-soft;
      border-radius: 8px 8px 0 0;
      margin-bottom: 0;

      &::before {
        border-radius: 8px 8px 0 0;
      }

      .v-list-item__title > span:not(.new-badge) {
        color: $accent;
      }

      .v-icon {
        color: $accent;
      }
    }

    // 子項目區: 下凹面板 (recessed panel)
    .v-list-group__items {
      background: rgba(0, 0, 0, 0.2);
      box-shadow:
        inset 0 3px 5px -2px rgba(0, 0, 0, 0.35),
        inset 0 -1px 0 rgba(255, 255, 255, 0.02);
      padding: 4px 0 6px;
      border-radius: 0 0 8px 8px;
    }
  }

  // 子項目
  .menu-bgc {
    min-height: 44px;
    margin: 1px 4px;
    padding: 0 12px 0 28px;
    border-radius: 6px;
    position: relative;
    transition: background 0.2s $ease;

    &::before {
      border-radius: 6px;
    }

    &:hover {
      background: $accent-softer;

      .sec-font-color {
        color: rgba(255, 255, 255, 0.96);
      }
    }

    &.v-list-item--active {
      background: $accent-soft;

      .sec-font-color {
        color: #5DADE2;
        font-weight: 500;
      }
    }
  }

  // 在 category 之下的子項目: 多縮排 + 左側 2px 分類色條
  // 用 margin !important 壓過 Vuetify nav-mode 預設的 margin-bottom, 讓彩條無斷層
  .category-child.menu-bgc {
    padding-left: 36px;
    margin: 0 4px !important;
    border-radius: 0 6px 6px 0;
    box-shadow: inset 2px 0 0 var(--cat-color, transparent);

    // hover/active 時保留左側分類色條
    &:hover,
    &.v-list-item--active {
      box-shadow: inset 2px 0 0 var(--cat-color, transparent);
    }
  }

  // category section label (取代原本的色塊): 細色條 + uppercase 標籤
  // padding-left 刻意比子項目小, 讓子項目產生縮排視覺
  .category-title {
    min-height: 28px;
    margin: 12px 4px 0 !important;
    padding: 0 8px 0 14px !important;
    cursor: default;
    pointer-events: none;
    border-radius: 0;
    box-shadow: inset 2px 0 0 var(--cat-color, transparent);

    &::before {
      display: none;
    }

    .v-list-item__content {
      padding: 4px 0 2px;
    }

    .v-list-item__title {
      font-size: 0.6875rem;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.55);
      letter-spacing: 0.1em;
      text-transform: uppercase;
      line-height: 1.4;
    }
  }

  // category 間的分隔線 (極淡)
  .menu-divider {
    border-color: rgba(255, 255, 255, 0.06) !important;
    margin: 6px 12px;
  }

  // 子項目文字
  .sec-font-color {
    color: rgba(255, 255, 255, 0.76);
    font-size: 0.875rem;
    transition: color 0.2s $ease;
  }

  // 父群組「NEW」pill 標記
  .new-badge {
    display: inline-flex;
    align-items: center;
    margin-left: 6px;
    padding: 1px 5px;
    font-size: 0.5625rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #fff;
    background: linear-gradient(135deg, #FF9800, #F44336);
    border-radius: 3px;
    line-height: 1.4;
    text-transform: uppercase;
  }

  // 群組展開動畫平滑化
  .v-list-group__items {
    .v-list-item {
      transition: background 0.2s $ease;
    }
  }
}

// 手機: 加大觸控區
@media (max-width: 599px) {
  .app--drawer {
    .menu-group .v-list-group__header {
      min-height: 52px;
    }

    .menu-bgc {
      min-height: 48px;
    }

    .category-title {
      min-height: 28px;
      margin-top: 16px;
    }

    .menu-list {
      padding: 10px 8px 16px;
    }
  }
}
</style>
